<template><div><h1 id="widerrufe-parametrisierungen" tabindex="-1"><a class="header-anchor" href="#widerrufe-parametrisierungen"><span>Widerrufe Parametrisierungen</span></a></h1>
<p>Widerrufe Parametrisierungen — Parametrisierung der LSV- und Debit Direct-Rückbuchungen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Maske werden die Einstellungen für den LSV- und Debid Direct-Import eingetragen. Sobald die Anzahl Durchgänge erreicht sind (z.B. wenn mindestens 3 aufeinanderfolgeneTransaktionen zu einer Zusage nicht bezahlt worden sind), wird die Transaktionen gemäss dieser Festlegungen verarbeitet und in der Tabelle &quot;mitfalnk&quot; auf Status 2 &quot;abgeschlossen&quot; gesetzt. LSV-Rückbuchungen werden zusammen mit den Gutschriften eingelesen. Eine widerrufene Transaktion wird gemäss dieser Festlegungen verarbeitet und in der Tabelle &quot;mitfalnk&quot; auf Status 2 &quot;abgeschlossen&quot; gesetzt.</p>
<p>Pfad:</p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Transaktionen mit Valuta +: x Tage</dt>
<dd>Berücksichtigt nur Transaktionen deren Valuta (aus Zusagenfakturierung) mindestens x Tage abgelaufen ist. Diese Einstellung dient der Sicherstellung, dass innerhalb von 2 Tagen nach Valuta eintreffende Zahlungen nicht als &quot;nicht bezahlt&quot; deklariert werden.</dd>
<dt>nicht bezahlt/Widerruf</dt>
<dd>Beschreibt, worauf sich die Festlegungen beziehen.</dd>
<dt>Zahlungsmodus</dt>
<dd>Der Zahlungsmodus wird auf den eingetragenen Wert gesetzt. Beim Eintrag vom Zahlungsmodus ESR wird die LSV/DD- Zeitscheibe beendet und eine neue Zeitscheibe mit Zahlungsmodus ESR erfasst). Die Zusage wird gem. den Einträgen unter &quot;Fakt&quot; sofort, oder erst mit der nächsten Jahresfakturierung, berücksichtigt. Sie erscheint auch in Mahnläufen, sofern sie den für die Mahnung definierten Kriterien entspricht. Bei allen anderen Zahlungsmodus wird eine neue Zusagen-Zeitscheibe erfasst. Die Beträge bleiben jedoch unverändert.</dd>
<dt>Fakturierung</dt>
<dd>Gilt nur für ESR! Folgende Fakturierungsvarianten sind möglich:
<table>
<thead>
<tr>
<th>Einstellung</th>
<th>Auswirkung</th>
</tr>
</thead>
<tbody>
<tr>
<td>sofort, unbedingt</td>
<td>Fakturierung wird sofort ausgelöst</td>
</tr>
<tr>
<td>sofort, bedingt</td>
<td>Fakturierung wird sofort ausgelöst, jedoch nur, wenn noch kein (Teil-)Beitrag bezahlt ist.</td>
</tr>
<tr>
<td>Jahresfakturierung</td>
<td>wird erst mit der nächsten Jahresfakturierung berücksichtigt</td>
</tr>
</tbody>
</table>
</dd>
<dt>Anzahl Durchgänge</dt>
<dd>Anzahl Durchgänge (die Anzahl Durchgänge entspricht der Anzahl nicht bezahlter Transaktionen pro Zusageart.), bis die Zahlungsart auf den im Feld &quot;Zahlungsmodus&quot; definierten Wert gesetzt wird. Eingabe von 0, 1, und &quot;&quot; lösen die Aktion mit dem 1. Auftreten aus.<br>Der Zählerstand bleibt auch bei einem allfälligen weiteren Zahlungseingang bestehen. Mit jeder Jahresfakturierung wird er jedoch auf 0 gesetzt.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/customer/zusagen.html#Zusagenfakturierung" title="11.2. Zusagenfakturierung">Zusagenfakturierung</RouteLink>, <RouteLink to="/manual/buchhaltung/lsv_dd_belastungen.html" title="3. LSV/DD-Belastungen">LSV/DD-Belastungen</RouteLink></p>
</div></template>


